module.exports = __webpack_public_path__ + "img/use-plugin.9e8c63e7.png";